<template>
    <div class="">
        <span v-if="hasFiles()" style="cursor: pointer">{{ $t("View") }}</span>
    </div>
</template>

<script>
export default {
  name: "ReportProductFiles",
  data: function() {
    return {
      collections: [],
      // We'll need to define properties in our data object,
      // corresponding to all of the data being injected from
      // the BaseEditorComponent class, which are:
      // - hotInstance (instance of Handsontable)
      // - row (row index)
      // - col (column index)
      // - prop (column property name)
      // - TD (the HTML cell element)
      // - cellProperties (the cellProperties object for the edited cell)
      hotInstance: null,
      TD: null,
      row: null,
      col: null,
      prop: null,
      value: null,
      cellProperties: null
    };
  },
  mounted() {
    this.TD.addEventListener("click", this.downloadFiles);
  },
  methods: {
    downloadFiles() {
      this.value.files.forEach(f => {
        window.open(f.url);
      });
    },
    hasFiles() {
      return this.value.files.length;
    }
  }
};
</script>

<style scoped>
div {
  white-space: normal;
}
</style>
